import { render, staticRenderFns } from "./SetPaperStepTwoSingle.vue?vue&type=template&id=a51abcaa&scoped=true&"
import script from "./SetPaperStepTwoSingle.vue?vue&type=script&lang=js&"
export * from "./SetPaperStepTwoSingle.vue?vue&type=script&lang=js&"
import style0 from "./SetPaperStepTwoSingle.vue?vue&type=style&index=0&id=a51abcaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51abcaa",
  null
  
)

export default component.exports